var _circle, _path, _path2, _path3, _path4;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgPpidInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.4993,
    cy: 27.4348,
    r: 27.4348,
    fill: "#E8F0F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9442 14.1016C19.8834 14.1016 14.1582 19.8268 14.1582 26.8876C14.1582 33.9484 19.8834 39.6736 26.9442 39.6736C34.005 39.6736 39.7302 33.9484 39.7302 26.8876C39.7302 19.8268 34.005 14.1016 26.9442 14.1016Z",
    stroke: "#39A3D6",
    strokeWidth: 1.71468,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.998 24.9453H27.2217V33.0061",
    stroke: "#39A3D6",
    strokeWidth: 1.71468,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1641 33.2812H30.2791",
    stroke: "#39A3D6",
    strokeWidth: 1.71468,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.416 19.7048C26.5721 19.6005 26.7557 19.5448 26.9434 19.5448C27.1952 19.5448 27.4367 19.6449 27.6147 19.8229C27.7928 20.0009 27.8928 20.2424 27.8928 20.4942C27.8928 20.682 27.8371 20.8655 27.7328 21.0217C27.6285 21.1778 27.4802 21.2995 27.3067 21.3713C27.1333 21.4432 26.9424 21.462 26.7582 21.4254C26.5741 21.3887 26.4049 21.2983 26.2721 21.1655C26.1394 21.0328 26.0489 20.8636 26.0123 20.6794C25.9757 20.4953 25.9945 20.3044 26.0663 20.1309C26.1382 19.9574 26.2599 19.8092 26.416 19.7048Z",
    fill: "#176CA7",
    fillOpacity: 0.15,
    stroke: "#39A3D6",
    strokeWidth: 1.71468
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpidInfo);
export default __webpack_public_path__ + "static/media/ppid-info.ec369212bd59b0baa4488a9dc4b0b333.svg";
export { ForwardRef as ReactComponent };